import React, { useState, } from "react"
import {defineMessages, FormattedMessage} from "react-intl"
import AuthService from "../../state/auth/AuthService"
import LoadingSpinner from "../../common/spinner/loading.component"
import {Button} from "react-bootstrap"

const messages = defineMessages({
    forgot_password_title: {
        id: "login.forgot_password.title",
        defaultMessage: "Forgot your password?",
    },
    forgot_password_text: {
        id: "login.forgot_password.text",
        defaultMessage: "Enter the email address associated with your account " +
            "and we'll send you instructions to reset your password.",
    },
    email_sent_message: {
        id: "login.forgot_password.feedback",
        defaultMessage: "If there is an account associated to this email address, " +
            "instructions to reset the password have been sent.",
    },
    email_address_label: {
        id: "login.forgot_password.email_label",
        defaultMessage: "Email address",
    },
    continue_label: {
        id: "login.forgot_password.continue_label",
        defaultMessage: "Continue",
    }
})

const ForgotPasswordComponent = () => {
    const [email, setEmail] = useState("")
    const [emailSent, setEmailSent] = useState({
        isSent: false,
        isLoading: false
    })

    const submit = async () => {
        setEmailSent({
            isSent: false,
            isLoading: true
        })
        const res = await AuthService.SendPasswordResetEmail(email)
        setEmailSent({
            isSent: res,
            isLoading: false
        })
    }

    return (
        <div>
            <h3 className="mt-2">
                <FormattedMessage{...messages.forgot_password_title}/>
            </h3>

            {emailSent.isSent ?
                <div className="mt-4 text-center text-success pb-5 pt-4">
                    <FormattedMessage{...messages.email_sent_message}/>
                </div> :
                <>
                    <div className="mt-4">
                        <FormattedMessage{...messages.forgot_password_text}/>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12 text-center">
                            <div className="form-group text-left">
                                <label htmlFor="inputEmail">
                                    <FormattedMessage{...messages.email_address_label}/>
                                </label>
                                <input
                                    name="email"
                                    type="email"
                                    id="inputEmail"
                                    className="form-control"
                                    required
                                    onChange={e => setEmail(e.target.value)}
                                />
                            </div>
                            <Button
                                onClick={() => submit()}
                                className="btn btn-primary col-12"
                                disabled={emailSent.isLoading}>
                                {emailSent.isLoading ?
                                    <LoadingSpinner height={20} width={3} className="px-5"/> :
                                    <FormattedMessage{...messages.continue_label}/>}
                            </Button>
                        </div>
                    </div>
                </>
            }
              
        </div>
    )
}


export default ForgotPasswordComponent


// WEBPACK FOOTER //
// ./src/auth/components/ForgotPasswordComponent.tsx